import { c as p } from "./string-B9G_tJZ-.js";
var s = /* @__PURE__ */ ((e) => (e[e.Mainnet = 1] = "Mainnet", e[e.Optimism = 10] = "Optimism", e[e.Matic = 137] = "Matic", e[e.Base = 8453] = "Base", e[e.Sepolia = 11155111] = "Sepolia", e))(s || {});
const n = {
  1: {
    rpcUrls: ["https://mainnet.infura.io"],
    chainName: "Ethereum Mainnet",
    displayName: "Ethereum",
    alternateNames: ["mainnet", "eth"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18
    },
    // @todo: we should really just match the chains.json structure here and do an array of structs
    blockExplorerUrls: ["https://etherscan.io"]
  },
  10: {
    rpcUrls: ["https://mainnet.optimism.io/"],
    chainName: "Optimism Mainnet",
    displayName: "Optimism",
    alternateNames: ["op", "oeth"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "OETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://optimistic.etherscan.io/"]
  },
  8453: {
    rpcUrls: ["https://mainnet.base.org"],
    chainName: "Base Mainnet",
    displayName: "Base",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://basescan.org"]
  },
  137: {
    rpcUrls: ["https://polygon-rpc.com"],
    chainName: "Polygon Mainnet",
    displayName: "Polygon",
    alternateNames: ["matic", "pol"],
    nativeCurrency: {
      name: "POL",
      symbol: "POL",
      decimals: 18
    },
    blockExplorerUrls: ["https://polygonscan.com"]
  },
  11155111: {
    rpcUrls: ["https://rpc.sepolia.org"],
    chainName: "Ethereum Testnet Sepolia",
    displayName: "Sepolia",
    alternateNames: ["sep"],
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://sepolia.etherscan.io"]
  }
}, u = [
  1,
  8453,
  137,
  10
  /* Optimism */
], m = [
  11155111
  /* Sepolia */
], i = Object.keys(n).map((e) => parseInt(e)), c = (e) => i.includes(e);
function h(e, a = !1) {
  if (!c(e))
    throw new Error("Unsupported Network");
  const t = n[e];
  return a ? t.displayName : t.displayName.toLowerCase();
}
function y(e) {
  return m.includes(e);
}
function E(e) {
  var o;
  const a = e.toLowerCase(), t = p(a);
  if (t in s)
    return s[t];
  for (const r of i) {
    const l = n[r];
    if (l.displayName.toLowerCase() === a || (o = l.alternateNames) != null && o.includes(a))
      return r;
  }
  return null;
}
const b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MAIN_NETWORKS: u,
  NETWORK_CONFIGS: n,
  NetworkId: s,
  SUPPORTED_NETWORKS: i,
  TEST_NETWORKS: m,
  getDisplayNameForNetworkId: h,
  isSupportedNetwork: c,
  isTestnet: y,
  resolveChainIdByName: E
}, Symbol.toStringTag, { value: "Module" }));
export {
  u as M,
  s as N,
  i as S,
  m as T,
  c as a,
  n as b,
  h as g,
  y as i,
  b as n,
  E as r
};
